import { useMemo } from 'react'
import { CurrenciesEnum } from 'core/types/CurrenciesEnum'
import { currencyFormatterFactory } from 'core/helpers/formatter'
import { t } from 'translate/i18n'
import { useDevelopmentError } from 'context/ErrorReporting'

interface CurrencyProps {
  currency: CurrenciesEnum
  amount: number
}

export const Currency: React.FC<CurrencyProps> = ({ currency, amount }) => {
  const logDevError = useDevelopmentError()
  const normalizedCurrencyFormatting = useMemo(() => {
    switch (currency) {
      case CurrenciesEnum.USD:
      case CurrenciesEnum.USDC:
        return CurrenciesEnum.USD
      case CurrenciesEnum.BRL:
      case CurrenciesEnum.BRLA:
        return CurrenciesEnum.BRL
      default:
        logDevError(
          `Currency display normalization not setup for currency ${currency}`,
          module
        )
        return currency
    }
  }, [currency])
  const formatter = useMemo(
    () => currencyFormatterFactory(normalizedCurrencyFormatting),
    [currency]
  )
  const formattedParts = useMemo(
    () => formatter.formatToParts(amount),
    [amount, formatter]
  )
  return (
    <span className='price'>
      {amount <= 0 ? (
        <span className='no-amount'>{t('components.offerPrice.noPrice')}</span>
      ) : (
        formattedParts.map(({ type, value }, key) => {
          return (
            <span key={key} className={type}>
              {value}
            </span>
          )
        })
      )}
    </span>
  )
}
